/* ==========================================================================
   Barra de compra fija · Daza (snippets/daza-compra-fija.liquid)
   --------------------------------------------------------------------------
   - Visible solo cuando el botón de compra de la ficha ya quedó por ENCIMA
     de la pantalla (no antes de llegar a él).
   - Al cambiar de variante, Dawn (product-info.js) publica variantChange con
     el HTML de la sección: la barra toma de ahí su versión nueva (precio,
     variante del formulario, selector), sin formatear dinero en JS.
   - Su selector mueve el de la ficha (clic en el radio o cambio del select),
     así la ficha y la barra nunca quedan en variantes distintas.
   - Mientras se ve, marca body.daza-compra-visible y --daza-compra-alto: el
     CSS sube WhatsApp y el video y deja hueco al final de la página.
   ========================================================================== */

if (!customElements.get('daza-compra-fija')) {
  customElements.define(
    'daza-compra-fija',
    class DazaCompraFija extends HTMLElement {
      connectedCallback() {
        this.seccion = this.dataset.section;
        this.raiz = document.getElementById(`MainProduct-${this.seccion}`);
        this.objetivo =
          document.getElementById(`ProductSubmitButton-${this.seccion}`)?.closest('.product-form__buttons') ||
          this.raiz?.querySelector('.product-form__buttons');
        if (!this.objetivo) return;

        this.medir = this.medir.bind(this);
        this.alCambiar = this.alCambiar.bind(this);

        // La raíz se alarga hacia abajo: «no intersecta» solo puede significar
        // que el botón quedó por ENCIMA de la pantalla. Con la raíz normal, en
        // móvil (botón bajo el pliegue) un salto de un solo fotograma de abajo
        // a arriba —un ancla, un deslizamiento rápido— nunca lo ve cruzar y la
        // barra no sale. root: document hace que el margen valga también
        // dentro del iframe del editor de temas.
        const avisar = ([entrada]) => this.mostrar(!entrada.isIntersecting);
        const opciones = { rootMargin: '0px 0px 100000px 0px' };
        try {
          this.observador = new IntersectionObserver(avisar, { ...opciones, root: document });
        } catch (e) {
          this.observador = new IntersectionObserver(avisar, opciones);
        }
        this.observador.observe(this.objetivo);

        this.addEventListener('change', this.alCambiar);
        window.addEventListener('resize', this.medir, { passive: true });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.desuscribir = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (!data || data.sectionId !== this.seccion || !data.html) return;
            const nuevo = data.html.getElementById(this.id)?.querySelector('.daza-compra-fija__inner');
            const actual = this.querySelector('.daza-compra-fija__inner');
            if (nuevo && actual) actual.replaceWith(nuevo);
            // Si el cambio salió de esta barra, el foco vuelve a su selector
            // (Dawn lo pone en el radio de la ficha justo después de esto).
            if (this.cambioPropio) {
              this.cambioPropio = false;
              setTimeout(() => this.querySelector('.daza-compra-fija__select')?.focus({ preventScroll: true }));
            }
          });
        }
      }

      disconnectedCallback() {
        this.observador?.disconnect();
        this.desuscribir?.();
        this.removeEventListener('change', this.alCambiar);
        window.removeEventListener('resize', this.medir);
        document.body.classList.remove('daza-compra-visible');
      }

      alCambiar(evento) {
        const select = evento.target.closest('.daza-compra-fija__select');
        if (!select || !this.raiz) return;
        const id = select.selectedOptions[0]?.dataset.optionValueId;
        if (!id) return;
        this.cambioPropio = true;

        const radio = this.raiz.querySelector(`input[type="radio"][data-option-value-id="${id}"]`);
        if (radio) {
          radio.click();
          return;
        }
        const opcion = this.raiz.querySelector(`select option[data-option-value-id="${id}"]`);
        if (opcion) {
          const principal = opcion.closest('select');
          principal.value = opcion.value;
          principal.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      mostrar(ver) {
        this.classList.toggle('is-visible', ver);
        this.setAttribute('aria-hidden', String(!ver));
        this.inert = !ver;
        document.body.classList.toggle('daza-compra-visible', ver);
        if (ver) this.medir();
      }

      medir() {
        document.documentElement.style.setProperty('--daza-compra-alto', `${this.offsetHeight}px`);
      }
    }
  );
}
